import {
  Divider,
  FormControlLabel,
  Grid,
  Paper,
  Radio,
  RadioGroup,
} from "@mui/material";
import DialogActions from "@mui/material/DialogActions";
import dayjs from "dayjs";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { connect } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import swal from "sweetalert";
import AutoComplete from "../../components/Comman/AutoComplete";
import { ButtonCompo } from "../../components/Comman/Button";
import { LabelCompo } from "../../components/Comman/Label";
import LandingScreenHeader from "../../components/Comman/LandingScreenHeader";
import { TextFieldCompo } from "../../components/Comman/TextFieldCompo";
import { redColor, titleColor } from "../../config/ColorObj";
import { getUpdatedBeatByUserType } from "../../Slice/beat.slice";
import { getUpdatedOutletListByBeatIds } from "../../Slice/outlet.slice";
import endpoint from "../../config/endpoints";
import {
  checkedListEmptyMsg,
  deleteErrorMsg,
  maxRecordMsg,
  noInternetMsg,
  saveFailedMsg,
  savemsg,
  saveWarningMsg,
  serverMsg,
} from "../../config/messageconstant";
import { apiGet, apiPost } from "../../utils/api_service";
import { showLoador, showNotification } from "../Landing/Landing.slice";
import OutletTargetTable from "./OutletTargetTable";

const OutletTargetForm = ({
  showLoador,
  showNotification,
  getUpdatedBeatByUserType,
  beatList,
  getUpdatedOutletListByBeatIds,
  outletList,
}) => {
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [type, setType] = useState("1");
  const [yearObj, setYearObj] = useState({});
  const [rowList, setRowList] = useState([]);
  const [prodList, setProdList] = useState([]);
  const [_minDate, setMinDate] = useState(null);
  const [_maxDate, setMaxDate] = useState(null);
  const [toMinDate, setToMinDate] = useState(null);
  const [toMaxDate, setToMaxDate] = useState(null);
  const [formErrors, setFormErrors] = React.useState({});
  const saveResponse = useRef(null);
  const params = useParams();
  const [beat, setBeat] = useState({});
  const [outlet, setOutlet] = useState({});
  const [beatLists, setBeatList] = useState([]);

  const changeHandler = (e) => {
    const { name, value } = e.target;

    if (name === "type") {
      if (value == 0) {
        setClearRuQtyOnProdPopUp(true);
      }

      setType(value);
      const updatedRows = rowList
        .filter((row) => row.index == 1)
        .map((row) => {
          return {
            ...row,
            amount: value == 0 ? "0" : row.amount,
          };
        });
      setRowList(updatedRows);
    }
  };

  const memoizedBeatOptions = useMemo(() => {
    return beatList?.beatByUserType || [];
  }, [beatLists]);

  const changeHandlerForDropdown = useCallback((name, dropdown, newValue) => {
    setFormErrors({});

    if (name === "beat") {
      setBeat(newValue);

      if (newValue && newValue.id && newValue.id != "") {
        let beatJson = {
          beatIds: newValue.id,
        };
        showLoador({ loador: true });
        getUpdatedOutletListByBeatIds({ beatIds: beatJson }).then(
          ({ success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            }
          }
        );
      }
    } else if (name === "outlet") {
      const fyDates = JSON.parse(
        localStorage.getItem("isOutletTargetFyDate") || "{}"
      );

      const fyFromDate = fyDates.fromDate;
      const fyToDate = fyDates.toDate;

      if (newValue) {
        setOutlet(newValue);

        showLoador({ loador: true });
        apiGet({
          url: endpoint.outletTarget + "/by-outlet-id?outletId=" + newValue.id,
        }).then((response) => {
          showLoador({ loador: false });
          if (response?.data?.data?.length) {
            const mappedRows = response.data.data.map((item, idx) => {
              let toDtObj = null;
              if (item.toDate) {
                const [toDay, toMonth, toYear] = item.toDate
                  .split("-")
                  .map(Number);
                toDtObj = dayjs(new Date(toYear, toMonth - 1, toDay));
              }

              return {
                index: idx + 1,
                frmDt: item.fromDate || fyFromDate,
                fromDate: item.fromDate || fyFromDate,
                toDt: toDtObj,
                toDate: item.toDate || "",
                amount: item.targetAmt || "0",
                sortOrder: idx + 1,
              };
            });

            setRowList(mappedRows);
          } else {
            const [day, month, year] = fyFromDate?.split("-").map(Number);
            const newFromDate = dayjs(new Date(year, month - 1, day));

            setRowList([
              {
                index: 1,
                name: "",
                frmDt: fyFromDate,
                fromDate: fyFromDate,
                toDt: newFromDate.add(1, "day"),
                amount: "0",
                sortOrder: 1,
              },
            ]);
          }
        });

        // set financial year bounds
        const [day, month, year] = fyFromDate?.split("-").map(Number);
        const [toDay, toMonth, toYear] = fyToDate?.split("-").map(Number);
        const newFromDate = dayjs(new Date(year, month - 1, day));
        const newToDate = dayjs(new Date(toYear, toMonth - 1, toDay));
        const newToMinDate = dayjs(new Date(year, month - 1, day + 1));

        setMinDate(newFromDate);
        setToMinDate(newToMinDate);
        setMaxDate(newToDate);
        setToMaxDate(newToDate);
      }
    }
  });

  useEffect(() => {
    if (navigator.onLine) {
      showLoador({ loador: true });
      getUpdatedBeatByUserType().then(({ success, response }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        } else {
          setBeatList(response);
        }
      });
    }
  }, []);

  useEffect(() => {}, []);

  const onCancel = () => {
    navigate(-1);
  };

  const totalAmt = useMemo(() => {
    return rowList.reduce((sum, item) => sum + parseFloat(item.amount || 0), 0);
  }, [rowList]);

  const handleRowChange = (index, field, value) => {
    const updatedRows = rowList.map((row) => {
      if (row.index === index) {
        if (field === "toDt") {
          value = value ? value : null;
        }
        return {
          ...row,
          [field]: value,
          toDate: field === "toDt" && dayjs(value).format("DD-MM-YYYY"),
        };
      }
      return row;
    });
    setRowList(updatedRows);
  };

  const validateRow = (row) => {
    let errors = {};
    setFormErrors({});

    if (!row.toDt || row.toDt === "") {
      errors.toDtError = "To Date is required.";
    }

    if (type != 0) {
      if (row.amount === "") {
        errors.amountError = "Amount is required.";
      } else if (row.amount < 1) {
        errors.amountError = "Amount should be more than zero.";
      }
    }

    return errors;
  };

  const handleAddRow = () => {
    const lastRow = rowList[rowList.length - 1];

    const errors = validateRow(lastRow);

    let newFromDateObj = null;

    if (Object.keys(errors).length > 0) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        [lastRow.index]: errors,
      }));
      return;
    }

    let newFromDate = "";
    if (lastRow && lastRow.toDt) {
      newFromDateObj = dayjs(lastRow.toDt).add(1, "day");
      newFromDate = newFromDateObj.format("DD-MM-YYYY");
      const [toDay, toMonth, toYear] = newFromDate?.split("-").map(Number);
      const newToMinDate = dayjs(new Date(toYear, toMonth - 1, toDay + 1));
      setToMinDate(newToMinDate);
      if (dayjs(lastRow.toDt).format("DD-MM-YYYY") === yearObj.toDate) {
        showNotification({ msg: maxRecordMsg, severity: "error" });
        return;
      }
    }

    setRowList((prevRowList) => [
      ...prevRowList,
      {
        index: prevRowList.length + 1,
        name: "",
        frmDt: newFromDate,
        fromDate: newFromDate,
        toDt: dayjs(newFromDateObj).add(1, "day"),
        toDate: dayjs(lastRow.toDt).format("DD-MM-YYYY"),
        amount: "0",
        sortOrder: prevRowList.length + 1,
      },
    ]);
  };

  const handleDeleteRow = () => {
    if (rowList.length > 1) {
      const updatedRowList = rowList.slice(0, -1);
      setRowList(updatedRowList);
    } else {
      showNotification({ msg: deleteErrorMsg, severity: "error" });
    }
  };

  const saveOutletTargetData = () => {
    const lastRow = rowList[rowList.length - 1];

    if (navigator.onLine) {
      if (rowList.length !== 0) {
        const errors = validateRow(lastRow);

        if (Object.keys(errors).length > 0) {
          setFormErrors((prevErrors) => ({
            ...prevErrors,
            [lastRow.index]: errors,
          }));
          return;
        }

        const fyDates = JSON.parse(
          localStorage.getItem("isOutletTargetFyDate") || "{}"
        );
        const fyToDate = fyDates.toDate || "31-03-2026";

        const finalToDate =
          lastRow && lastRow.toDt
            ? dayjs(lastRow.toDt).format("DD-MM-YYYY")
            : lastRow && lastRow.toDate
            ? lastRow.toDate
            : "";

        if (finalToDate !== fyToDate) {
          showNotification({
            msg:
              'Final "To Date" must be ' +
              fyToDate +
              ". Current: " +
              (finalToDate || "not set") +
              ".",
            severity: "error",
          });
          return;
        }

        let dataToSave = {};

        const saveList = rowList.map((rowItem) => {
          return {
            outLet: { id: outlet ? outlet.id : "" },

            fromDate: rowItem.frmDt
              ? dayjs(rowItem.frmDt, "DD-MM-YYYY").format("DD-MM-YYYY")
              : "",

            toDate: rowItem.toDt
              ? dayjs(rowItem.toDt).format("DD-MM-YYYY")
              : "",

            targetAmt: rowItem.amount,
          };
        });

        dataToSave = saveList;

        const jsonData = JSON.stringify(dataToSave);

        swal({
          title: "Are you sure?",
          text: saveWarningMsg,
          icon: "warning",
          buttons: true,
          dangerMode: true,
        }).then((willDelete) => {
          if (willDelete) {
            showLoador({ loador: true });
            apiPost({
              url: endpoint.outletTarget + "/save-list",
              postBody: jsonData,
            }).then(({ success, data }) => {
              showLoador({ loador: false });
              if (success) {
                saveResponse.current = data.data;
                showNotification({ msg: savemsg });
                setRowList([]);
                setName("");
                setYearObj({});
                window.location.reload();
              } else {
                showNotification({ msg: saveFailedMsg, severity: "error" });
              }
            });
          }
        });
      } else {
        showNotification({ msg: checkedListEmptyMsg, severity: "error" });
      }
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  return (
    <>
      <Paper
        sx={{
          p: 2,
          borderRadius: 2,
        }}
        elevation={0}
      >
        <LandingScreenHeader
          screenTitle={"Outlet Target"}
          showTable={false}
          showBackButton={true}
          showAddButton={false}
          onCancel={onCancel}
        />
        <div>
          <br></br>
          <Grid container item xs={12} spacing={2} alignItems="center">
            {/*Beat DD */}
            <Grid
              item
              xs={12}
              sm={4}
              container
              direction="row"
              alignItems="center"
              spacing={1}
            >
              <Grid item xs={3}>
                <LabelCompo
                  className="text-black"
                  style={{ fontSize: 16, color: redColor }}
                  label="*"
                />
                <LabelCompo
                  className="text-black"
                  style={{ fontSize: 16, color: titleColor }}
                  label="Beat :"
                />
              </Grid>
              <Grid item xs={9}>
                <AutoComplete
                  keyColName="id"
                  placeHolder="Select Beat"
                  value={beat ? beat.id : ""}
                  name="beat"
                  options={memoizedBeatOptions}
                  errorText={
                    formErrors["beatError"] ? formErrors["beatError"] : ""
                  }
                  isError={
                    formErrors["beatError"] ? formErrors["beatError"] : ""
                  }
                  onChange={changeHandlerForDropdown}
                />
              </Grid>
            </Grid>

            {/*Outlet DD */}
            <Grid
              item
              xs={12}
              sm={4}
              container
              direction="row"
              alignItems="center"
              spacing={1}
            >
              <Grid item xs={3}>
                <LabelCompo
                  className="text-black"
                  style={{ fontSize: 16, color: redColor }}
                  label="*"
                />
                <LabelCompo
                  className="text-black"
                  style={{ fontSize: 16, color: titleColor }}
                  label="Outlet :"
                />
              </Grid>
              <Grid item xs={9}>
                <AutoComplete
                  keyColName="id"
                  placeHolder="Select Outlet"
                  value={outlet ? outlet.id : ""}
                  name="outlet"
                  options={outletList?.outletByUserType}
                  errorText={
                    formErrors["outletError"] ? formErrors["outletError"] : ""
                  }
                  isError={
                    formErrors["outletError"] ? formErrors["outletError"] : ""
                  }
                  onChange={changeHandlerForDropdown}
                />
              </Grid>
            </Grid>

            {/*Amount*/}
            <Grid
              item
              xs={12}
              sm={2}
              container
              direction="row"
              alignItems="center"
              spacing={1} // Increased spacing for better separation
            >
              <Grid item xs={4.7}>
                {" "}
                {/* Adjusted xs for better label width */}
                <LabelCompo
                  className="text-black"
                  style={{ fontSize: 16, color: titleColor }}
                  label="Amount :"
                />
              </Grid>
              <Grid item xs={7.2}>
                {" "}
                {/* Adjusted xs for text field */}
                <TextFieldCompo
                  placeHolder="Amount"
                  color="primary"
                  name="totalAmt"
                  size="small"
                  value={totalAmt.toFixed(2)}
                  onChange={changeHandler}
                  disabled={true}
                  style={{ width: "100px" }} // Use width instead of maxWidth for consistency
                />
              </Grid>
            </Grid>
          </Grid>
          <Divider />
          <br />

          <Grid
            item
            sm={12}
            xs={12}
            md={12}
            lg={12}
            container
            justifyContent="space-between"
          >
            <OutletTargetTable
              rowList={rowList}
              handleRowChange={handleRowChange}
              handleAddRow={handleAddRow}
              toMinDate={toMinDate}
              toMaxDate={toMaxDate}
              formErrors={formErrors}
              type={type}
              handleDeleteRow={handleDeleteRow}
            />
          </Grid>

          <DialogActions>
            <Grid
              item
              justifyContent={"flex-end"}
              gap={2}
              xs={12}
              sm={12}
              md={1}
              flexDirection={"row"}
              display={"flex"}
            >
              <Grid justifyContent={"flex-end"} item>
                <ButtonCompo
                  size="medium"
                  onClick={() => saveOutletTargetData()}
                  variant="contained"
                  name={"Save"}
                />
              </Grid>
            </Grid>
          </DialogActions>
        </div>
      </Paper>
    </>
  );
};
const mapStateToProps = (state) => ({
  beatList: state.beat,
  outletList: state.outlet,
});
const mapDispatchToProps = {
  showNotification,
  showLoador,
  getUpdatedBeatByUserType,
  getUpdatedOutletListByBeatIds,
};
export default connect(mapStateToProps, mapDispatchToProps)(OutletTargetForm);
